import type { FaireProductEntity } from "../../entity_types/product";

export const p_n4xnjmzg7j: FaireProductEntity = {
  token: "p_n4xnjmzg7j",
  type: "product",
  name: "Minnesota Village Folk Sliced Wood Ornament",
  brandName: "Token Atelier",
  imageUrl:
    "https://cdn.faire.com/fastly/a48bd575f850da2fee0dcc9318e30b2f96092bde30df0cf59a52694cc5a391db.png",
  priceDollars: 3.25,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/03d3ee1fb5f434e6df17e7dc1c736a1495b095d51c2a1be7cbc7853a2ab739fc.webp",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
